import React from "react";
import "../CampaignComponent/CampaginComponentCss/AabhiyanSevenPoints.css";

export default function AabhiyanSevenPoints() {
  const data = [
    {
      id: "1",
      color: "#C6DCFF",
      title: "सुशासनयुक्त पंचायत",
      points: [
        " ग्रामस्थांच्याई सर्व तक्रारी निकाली काढणे.",
        " ग्रामपंचायतीची वेबसाईट तयार करुन त्यािवर सर्व माहिती प्रसिध्द् करणे.",
        " गावात सीसीटीव्हीे बसविणे.",
        " गावातील पात्र लाभार्थ्यांना आयुषमान भारत कार्ड उपलब्धर करुन देणे.",
        " गावातील पात्र दिव्यांगांना ओळखपत्र मिळवून देणे.",
        " ग्रामविकास समिती कार्यरत करणे",
      ],
    },
    {
      id: "2",
      color: "#FFA6E9",
      title: "सक्षमपंचायत",
      points: [
        " ग्रामपंचायतींची घरपट्टी व पाणीपट्टी ८० टक्यांया पेक्षा जास्तच वसूल करणे.",
        "हजार लोकसंख्येतमागे रुपये २ लाख लोकवर्गणी गोळा करुन त्याकमधून लोकोपयोगी कामे करणे.",
        " ग्रामपंचायतीचे स्वयतःचे उत्पीन्नल वाढविण्याकसाठी विविध उपाययोजना हाती घेणे.",
        "ग्रामपंचायतीचे स्वतःचे स्वउत्पन्न",
      ],
    },
    {
      id: "3",
      color: "#C8ABFF",
      title: "जलसमृद्ध, स्वच्छवहरितगाव",
      points: [
        " गावातील सर्व घरांना नळाद्वारे शुध्दग पाणी पुरवठा करणे.",
        " सौर उर्जेचा वापर करुन वीज देयके शून्या्वर आणणे.",
        " पाण्या्च्यार स्त्रो तांचे बळकटीकरण करणे.",
        " अपारंपारीक उर्जेचा वापर वाढविणे.",
        " वृक्षलागवड व वृक्षसंवर्धन करणे.",
        " गावातील घनकच-याचे व सांडपाण्या चे योग्य व्य वस्था पन करणे.",
      ],
    },
    {
      id: "4",
      color: "#8FD4FF",
      title: "मनरेगा व इतर योजनांचेअभिसरण",
      points: [
        " रोजगार हमी योजनेची प्रभावी अंमलबजावणी करणे.",
        " योजनेतून माती व जलसंधारण, घनकचरा व्यावस्थाापन, जनावरांचा गोठा, कुक्कु टपालन शेड, बायोगॅस, शेळीपालन शेड,कांदाचाळ इ. कामे हाती घेणे.",
        " घरकुल बांधकामात या योजनेतून रु. २८,०००/- चे योगदान घेणे.",
      ],
    },
    {
      id: "5",
      color: "#72A8FF",
      title: "गावपातळीवरील संस्था सक्षमीकरण",
      points: [
        " ग्रामपंचायत कार्यालयात सर्व सोयीसुविधा उपलब्ध् करुन घेणे.",
        " गावांतील शाळा व अंगणवाड्यांचा दर्जा उंचावणे.",
        " गावांत जास्ती त जास्त सौर उर्जेचा वापर करणे.",
        " गावातील स्मतशानभूमी विकास करणे.",
        " गावात क्रीडांगण व व्याायामशाळा उपलब्ध. करुन देणे.",
      ],
    },
    {
      id: "6",
      color: "#FFF79E",
      title: "उपजीविका विकास व सामाजिकन्याय",
      points: [
        " मंजूर घरकुलांचे काम पूर्ण करुन घेणे.",
        " गावातील बचत गटांचा विकासात सक्रीय सहभाग घेणे.",
        " बचत गटांतील जास्ती त जास्त महिलांना लखपती दिदी करणे.",
        " गावातील युवकांना कौशल्य विषयक प्रशिक्षण देऊन रोजगार संधी देणे.",
        " गावात शेती गट स्थानपन करुन त्यांिची उत्पाेदकता वाढविणे.",
      ],
    },
    {
      id: "7",
      color: "#C6DCFF",
      title: "लोक सहभाग व श्रमदानातून लोकचळवळ",
      points: [
        " लोकसहभाग व श्रमदानातून चळवळ उभी करणे.",
        " आठवडयातून किमान एक दिवस श्रमदान करणे.",
        " गावातील रस्तेक दुरुस्तन करुन दळणवळणाला चालना देणे.",
      ],
    },
  ];

  return (
    <section className="aabhiyan-wrapper">
      <h2 className="aabhiyan-title">अभियानाचे प्रमुख ७ घटक</h2>

      <div className="aabhiyan-grid">
        {data.map((box) => (
          <div className="aabhiyan-card" key={box.id}>
            <div className="aabhiyan-number" style={{ background: box.color }}>
              {box.id}
            </div>

            <div className="aabhiyan-card-content">
              <h3 className="aabhiyan-card-title">{box.title}</h3>

              <ul className="aabhiyan-list">
                {box.points.map((p, index) => (
                  <li key={index}>{p}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
